/*
 * <bundle-deals> for sections/bundle-deals.liquid (rewrite of the Shrine PRO behaviour).
 *  - ticking / unticking a product updates the total and greys its image
 *  - a variant select picks the matching variant, its price and image
 *  - "Add selected to cart" adds every ticked product in one /cart/add.js call,
 *    then opens Dawn's cart drawer (or goes to the cart / checkout)
 */
(function () {
  'use strict';
  if (customElements.get('bundle-deals')) return;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseFloat(cents) || 0;
    format = format || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return withDelimiters(cents, 2);
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(match[0], value);
  }

  class BundleDeals extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      this.percentageLeft = parseFloat(this.dataset.percentageLeft || '1');
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount || '0');
      this.updatePrices = this.dataset.updatePrices === 'true';
      this.skipUnavailable = this.dataset.skipUnavailable === 'true';
      this.skipCart = this.dataset.skipCart === 'true';

      this.checkboxes = Array.from(this.querySelectorAll('.bundle-deals__checkbox-js'));
      this.mediaItems = Array.from(this.querySelectorAll('.bundle-deals__media-item'));
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('.product-form__submit');
      this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => this.onCheckboxChange(checkbox));
      });
      this.querySelectorAll('.bundle-deals__variant-selects-js').forEach((wrapper) => {
        wrapper.querySelectorAll('select').forEach((select) => {
          select.addEventListener('change', () => this.onVariantChange(wrapper));
        });
        // match the first available variant's options on load
        this.selectInitialOptions(wrapper);
      });
      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.updateTotals();
    }

    checkboxFor(index) {
      return this.checkboxes.find((c) => c.dataset.index === String(index));
    }

    onCheckboxChange(checkbox) {
      const index = checkbox.dataset.index;
      checkbox.dataset.checked = checkbox.checked ? 'true' : 'false';
      const product = checkbox.closest('.bundle-deals__product-js');
      if (product) product.classList.toggle('bundle-deals__product--deselected', !checkbox.checked);
      const media = this.mediaItems[parseInt(index, 10)];
      if (media) media.classList.toggle('bundle-deals__media-item--disabled', !checkbox.checked);
      this.updateTotals();
    }

    variantsFor(wrapper) {
      if (!wrapper._variants) {
        const json = wrapper.querySelector('script[type="application/json"]');
        try {
          wrapper._variants = json ? JSON.parse(json.textContent) : [];
        } catch (e) {
          wrapper._variants = [];
        }
      }
      return wrapper._variants;
    }

    selectInitialOptions(wrapper) {
      const checkbox = this.checkboxFor(wrapper.dataset.index);
      if (!checkbox) return;
      const variant = this.variantsFor(wrapper).find((v) => String(v.id) === String(checkbox.dataset.id));
      if (!variant) return;
      wrapper.querySelectorAll('select').forEach((select, i) => {
        const value = variant.options[i];
        Array.from(select.options).forEach((option) => {
          if (option.value === value) select.value = value;
        });
      });
    }

    onVariantChange(wrapper) {
      const selected = Array.from(wrapper.querySelectorAll('select')).map((s) => s.value);
      const variants = this.variantsFor(wrapper);
      let variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      const checkbox = this.checkboxFor(wrapper.dataset.index);
      if (!checkbox) return;
      if (!variant || (!variant.available && this.skipUnavailable)) {
        checkbox.dataset.unavailable = 'true';
        this.updateTotals();
        return;
      }
      checkbox.dataset.unavailable = variant.available ? 'false' : 'true';
      const percentageLeft = parseFloat(wrapper.dataset.percentageLeft || '1');
      const fixedDiscount = parseFloat(wrapper.dataset.fixedDiscount || '0');
      const price = Math.round(variant.price * percentageLeft - fixedDiscount);
      const compare = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      checkbox.dataset.id = variant.id;
      checkbox.dataset.price = price;
      checkbox.dataset.comparePrice = compare;

      const product = checkbox.closest('.bundle-deals__product-js');
      if (product && this.updatePrices) {
        const priceEl = product.querySelector('.bundle-deals__price-js');
        const compareEl = product.querySelector('.bundle-deals__compare-price-js');
        if (priceEl) priceEl.textContent = formatMoney(price, this.moneyFormat);
        if (compareEl) compareEl.textContent = compare > price ? formatMoney(compare, this.moneyFormat) : '';
      }
      const media = this.mediaItems[parseInt(wrapper.dataset.index, 10)];
      const img = media && media.querySelector('.bundle-deals__media-item-img-js');
      if (img && variant.featured_image && variant.featured_image.src) {
        const src = variant.featured_image.src;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
        img.removeAttribute('srcset');
      }
      this.updateTotals();
    }

    selectedItems() {
      return this.checkboxes
        .filter((c) => c.checked && c.dataset.unavailable !== 'true')
        .map((c) => ({ id: parseInt(c.dataset.id, 10), quantity: 1 }));
    }

    updateTotals() {
      let total = 0;
      let compare = 0;
      let count = 0;
      this.checkboxes.forEach((c) => {
        if (!c.checked || c.dataset.unavailable === 'true') return;
        count += 1;
        total += parseFloat(c.dataset.price) || 0;
        compare += parseFloat(c.dataset.comparePrice) || 0;
      });
      total = Math.max(0, Math.round(total * this.percentageLeft - this.fixedDiscount));
      const totalEl = this.querySelector('.bundle-deals__total-price-js');
      const compareEl = this.querySelector('.bundle-deals__total-compare-price-js');
      if (this.updatePrices) {
        if (totalEl) totalEl.textContent = formatMoney(total, this.moneyFormat);
        if (compareEl) compareEl.textContent = compare > total ? formatMoney(compare, this.moneyFormat) : '';
      }
      if (this.submitButton) {
        if (count === 0) this.submitButton.setAttribute('aria-disabled', 'true');
        else this.submitButton.removeAttribute('aria-disabled');
      }
    }

    showError(message) {
      if (!this.errorWrapper) return;
      this.errorWrapper.toggleAttribute('hidden', !message);
      const text = this.errorWrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message || '';
    }

    setLoading(loading) {
      if (!this.submitButton) return;
      this.submitButton.classList.toggle('loading', loading);
      if (loading) this.submitButton.setAttribute('aria-disabled', 'true');
      else this.submitButton.removeAttribute('aria-disabled');
      const spinner = this.submitButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    }

    onSubmit(event) {
      event.preventDefault();
      const items = this.selectedItems();
      if (!items.length || (this.submitButton && this.submitButton.classList.contains('loading'))) return;
      this.showError('');
      this.setLoading(true);

      const cart = document.querySelector('cart-drawer');
      const body = { items: items };
      if (cart && !this.skipCart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const addUrl = (window.routes && window.routes.cart_add_url) || root + 'cart/add';

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message || '');
            return;
          }
          if (this.skipCart) {
            window.location = root + 'checkout';
            return;
          }
          if (!cart || !body.sections) {
            window.location = (window.routes && window.routes.cart_url) || root + 'cart';
            return;
          }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-deals', cartData: response });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.setLoading(false));
    }
  }

  customElements.define('bundle-deals', BundleDeals);
})();
